import React from 'react';
import './HelpIcon.css';

interface HelpIconProps {
  onClick: () => void;
  className?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ onClick, className = '' }) => {
  return (
    <button 
      className={`help-icon ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Get help about this advertising type"
      title="Click for explanation"
    >
      <i className="material-icons">help_outline</i>
    </button>
  );
};

export default HelpIcon;